<template lang="pug">
.bg-page
  .container
    section
      .title-decoration
        .dot
        .dot
        .dot
        .dot
      h1 {{ $route.meta.title }}
    .mb-5
    section
      //- .tab-wrap
        .tab-item(v-for="tab in tabs", @click="tabScroll(tab.offsetTop)") {{ tab.name }}
    .mb-10
    section
      .section-title 活動期間: 2017年11月23日－11月26日
      h4(style="color:#e0253f;margin-bottom: 16px;") 各項細部時間為下：
      .paragraph-wrap
        .em-title
          .icon-logo
          .text BYOC 報名時間
        .content 9/4 日起 － 額滿為主
      .paragraph-wrap
        .em-title
          .icon-logo
          .text BYOC 進/撤場時間
        .content
          ul
            li 進場時間：11/23 12:00 － 20:00。
            li 撤場時間：11/26 17:30。
      .paragraph-wrap
        .em-title
          .icon-logo
          .text BYOC 基本注意事項
        .content
          ul
            li 1. BYOC 玩家進場時需出示有照片的身份證件，以供工作人員核對為參加者本人，方可取得感應式識別手環。
            li 2. BYOC 玩家於本活動期間可憑感應式識別手環全天候 24 小時進出 BYOC 區。
            li 3. BYOC 區域需出示感應式識別手環或是可通行 BYOC 的通行證才可入場。
            li 4. BYOC 感應式識別手環僅限本人使用，不得授予他人進出 BYOC 區
      .paragraph-wrap
        .em-title
          .icon-logo
          .text 一般民眾進場參觀時間
        .em-title
          .icon-logo
          .text 日間入場時間：
        .content
          ul
            li 11/23 (四) 11:00 – 20:00
            li 11/24 (五) 11:00 – 20:00
            li 11/25 (六) 11:00 – 20:00
            li 11/26 (日) 11:00 – 17:00
      .paragraph-wrap
        .em-title
          .icon-logo
          .text 夜間入場時間:
        .content
          ul
            li 11/24 (五) 21:00 – 活動結束
            li 11/25 (六) 21:00 – 活動結束
            li ＊夜間入場僅開放給年滿18歲民眾，主辦單位將於入口處查驗身分證明文件。
      .paragraph-wrap
        .em-title
          .icon-logo
          .text 主辦單位將於每日日間入場時間結束後進行清場，除參展廠商及 BYOC 玩家外之一般民眾將禁止停留在場內。為了維護現場秩序及參加者之安全，若會場內人數已達飽和數量，將進行人數控管，限制進場。
      //- .paragraph-wrap
        .em-title
          .icon-logo
          .text 持 VIP卷 之民眾可於入口報到處換取一次性識別手環，憑 VIP手環 將享有入場快速通道及場內 專屬VIP 之服務。因安全考量，主辦單位保留夜間節目結束後清場權利。
    .mb-10
    section
      .section-title 平配圖
      .paragraph-wrap
        img(v-img:group="{src: ''}", src="~assets/flat-map.jpg", style="max-width: 100%")
        .content
          span •搭乘淡水線至捷運圓山站，下車後從 1 號出口出站。
    section
      .section-title 花博爭艷館地址：臺北市中山區玉門街 1 號
      .paragraph-wrap
        img(v-img:group="{src: ''}", src="~assets/location-map.png", style="max-width: 100%")
        .content
          span •搭乘淡水線至捷運圓山站，下車後從 1 號出口出站。
      .paragraph-wrap
        .em-title
          .icon-logo
          .text 搭乘公車
        .content
          ul
            li • 21、28、208、247、42、542、677、紅 2、紅 33、紅 34 （假日行駛）、紅 50 至捷運圓山站（玉門街）
            li • 246、208、542、紅 33、紅 34 （假日行駛）、218 至中山足球場站 （停靠民族東路）
      .paragraph-wrap
        .em-title
          .icon-logo
          .text 開車
        .content
          ul
            li • 花博公園圓山地下停車場：位於玉門街 1 號 B1
            li • 兒育中心停車場：位於玉門敦煌路口（兒育出入口）北側。
      .paragraph-wrap
        .em-title
          .icon-logo
          .text 客運
        .content
          ul
            li • 轉運站名稱：圓山交通廣場 （位於捷運圓山站西側庫倫街至酒泉街之間）
      gmap-map(:center="map.center",
        :zoom="17",
        mapTypeId="roadmap",
        style="width: 100%; height: 600px",
        :options="{styles: map.styles}"
        )
        gmap-marker(
          :key="index",
          v-for="(m, index) in map.markers",
          :position="m.position",
          :clickable="true",
          :draggable="false",
          :icon="map.iconImg"
          @click="map.center=m.position")
          gmap-info-window(:content="m.info.content")
    section
      .mb-4
      a.btn.ghost-btn(:href="googleCalenderEvent", target="_blank") 加到 Google 行事曆
      .mb-6
    section
      .section-title 小百科
    .paragraph-wrap
      .em-title
        .icon-logo
        .text BYOC？ Lan Party？ WirForce？
      .content
        ul
          li BYOC？ Lan Party？ WirForce？ 多麼陌生的名詞呀！
          li 這裡請容我們簡單為你介紹這些名詞所代表的意義 !
    .paragraph-wrap
      .em-title
        .icon-logo
        .text 什麼是 BYOC？
      .content
        ul
          li 「 BYOC 」是 Bring Your Own Computer 的縮寫，意指自行攜帶電腦。
          li WirForce 正是一場 BYOC 形式的社群盛會！
          li 今年的 WirForce 將有 1,000 席以上的 BYOC 名額，報名從 9 月 4 日起到額滿為止，記得趕緊報名！也別忘了到時候要帶齊你的傢伙來現場同歡。
    .paragraph-wrap
      .em-title
        .icon-logo
        .text 什麼是 Lan Party ?
      .content
        ul
          li Lan Party （網路派對）指的是由一群人暫時性、通常也是自發性的帶著他們的硬體配備與電腦 (BYOC)，在一個地方以區域網路連結的聚會，這樣的聚會大部份是以玩多人網路遊戲為目的，這樣的區域網路可大可小，從只有兩三個人到數千人都有。
          li 目前世界上最大型的 Lan Party 就是瑞典的「 DreamHack 」，從原先的數百人規模到 2002 年開始壯大，每年分為夏、冬兩季，每季參與人數高達 3,000 至 6,000 人，至 2009 年起，其規模已超過 20,000 名參加者。
    .paragraph-wrap
      .em-title
        .icon-logo
        .text 什麼是 WirForce？
      .content
        ul
          li 臺灣本土也有自己的 Lan Party 活動，就是 WirForce！
          br
          li WirForce 於 2014 年首度舉辦時採用邀請制並不對外開放，包含各界知名實況主、名人與選手等遊戲相關人士約 200 位，各自攜帶個人電腦、筆電、配備齊聚現場。會場內除打遊戲外，參加者可以進行各種合法活動；現場亦有許多線下趣味活動與節目，內容包羅萬象精彩萬分。透過全程轉播，2014 年 WirForce 結束後立即在遊戲與電競玩家中造成轟動，並成為臺灣遊戲電競史上無人可取代的黃金傳說，說是臺灣電競遊戲界春吶一點也不為過。
          br
          li 許多人為錯過此  2014  盛事感到極度遺憾與扼腕，於是 2015 年的 WirForce 決定開放場外玩家自由購票報名入場後，400 張 BYOC 座位於兩天內即銷售一空，活動三天中超過兩萬名玩家與二十家國內外知名廠商一起共襄盛舉；2016年 WirForce BYOC 座位擴增至 600 席，吸引 20 家知名品牌熱列支持，在臺北市花博公園爭艷館 C2 展區舉行，免費入場的人潮上看 7 萬、線上直播觀看人次高達 100 萬。四天三夜延續不斷電的電玩派對外，電競、派對、音樂、社群、實況、改裝、最新硬體及遊戲。
          br
          li 今年，2017 年， WirForce BYOC 座位擴增超過 1,000 席，讓我們再次一同創造亞洲有史以來最空前的電競盛會 - WirForce!
    .paragraph-wrap
      .em-title
        .icon-logo
        .text 我可以在 WirForce 裡做什麼？
      .content
        ul
          li 如上述所言，除了瘋狂打電動外，你可以在 WirForce 會場進行各種合法活動，包含各種桌遊、競賽，在空檔之餘觀賞影片或閒聊打屁，只要你想得到的都可以作為你的活動內容，我們完全不排斥各種多角化發展，甚至還會與你一起同樂。
          li WirForce 為四天三夜不間斷的活動，歡迎各位在期間內與新舊朋友一同盡情玩樂，但也請攝取足夠的水分與熱量，更要有足夠的睡眠，請大家務必要注意自己的身體健康與人身安全。
          li 若在活動期間感到任何不適，請立刻告知工作人員或前往服務台，我們會依據您的身體狀況作必要的處理。
    .paragraph-wrap
      .em-title
        .icon-logo
        .text WirForce 有任何服裝限制嗎？
      .content
        ul
          li 參加活動你不必正裝打扮，也無須費心扮裝，只要穿著你覺得舒服且不構成違法情事的裝束，其他的就是盡情享受這四天三夜吧！
    .paragraph-wrap
      .em-title
        .icon-logo
        .text 繳費相關說明
      .content
        .mb-3
        router-link.btn.ghost-btn(:to="{name: 'payment'}", target="_blank") 前往代碼繳費說明
    section
      .section-title 可用視覺下載
      router-link.btn.ghost-btn(:to="{name: 'download'}") 下載素材
    .mb-3
    .paragraph-wrap
      .content(style="font-size: 14px; color: #e0253f;")
       | 歡迎大家以各種形式參與 WirForce 2017！
       br
       | 請注意！若為商業使用需經主辦單位同意。
    .mb-40
</template>

<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'
import * as VueGoogleMaps from 'vue2-google-maps'
// import _ from 'lodash'
import wfLogo from 'assets/map-icon.png'

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyDtiDmHYTSsIX0G44z1UY6smB1_RT-kEio'
    // libraries: 'places', //// If you need to use place input
  }
})

export default {
  name: 'activity',
  beforeRouteEnter (to, from, next) {
    next(vm => {
    })
  },
  beforeRouteLeave (to, from, next) {
    next(vm => {
    })
  },
  props: {
    fullScreenCount: {
      type: Object
    },
    isMobile: {
      type: Boolean
    },
    mobileMenuSwitch: {
      type: [Boolean, Function]
    },
    isPortrait: {
      type: Boolean
    }
  },
  data () {
    return {
      tabs: [
        {
          name: '時間地點'
        },
        {
          name: '小百科'
        },
        {
          name: '可用視覺下載'
        }
      ],
      googleCalenderEvent: 'https://www.google.com/calendar/render?action=TEMPLATE&text=2017+Wirforce&dates=20171122T160000Z/20171126T173000Z&details=2017+Wirforce+正式啟動+更多資訊:+http://www.wirforce.com.tw&location=花博公園爭艷館&sf=true&output=xml',
      map: {
        center: {lat: 25.0699821, lng: 121.5210453},
        iconImg: wfLogo,
        styles: [
          {elementType: 'geometry', stylers: [{color: '#201720'}]},
          {elementType: 'labels.text.stroke', stylers: [{color: '#12161e'}]},
          {elementType: 'labels.text.fill', stylers: [{color: '#ff3565'}]},
          {
            featureType: 'administrative.locality',
            elementType: 'labels.text.fill',
            stylers: [{color: '#ff3565'}]
          },
          {
            featureType: 'poi',
            elementType: 'labels.text.fill',
            stylers: [{color: '#e0253f'}]
          },
          {
            featureType: 'poi.park',
            elementType: 'geometry',
            stylers: [{color: '#4B1A27'}]
          },
          {
            featureType: 'poi.park',
            elementType: 'labels.text.fill',
            stylers: [
              {color: '#ff3565'}
            ]
          },
          {
            featureType: 'road',
            elementType: 'geometry',
            stylers: [{color: '#301823'}]
          },
          {
            featureType: 'road',
            elementType: 'geometry.stroke',
            stylers: [{color: '#201720'}]
          },
          {
            featureType: 'road',
            elementType: 'labels.text.fill',
            stylers: [{color: '#e0253f'}]
          },
          {
            featureType: 'road.highway',
            elementType: 'geometry',
            stylers: [{color: '#e0253f'}]
          },
          {
            featureType: 'road.highway',
            elementType: 'geometry.stroke',
            stylers: [{color: '#201720'}]
          },
          {
            featureType: 'road.highway',
            elementType: 'labels.text.fill',
            stylers: [{color: '#e0253f'}]
          },
          {
            featureType: 'transit',
            elementType: 'geometry',
            stylers: [{color: '#e0253f'}]
          },
          {
            featureType: 'transit.station',
            elementType: 'labels.text.fill',
            stylers: [{color: '#ff3565'}]
          },
          {
            featureType: 'water',
            elementType: 'geometry',
            stylers: [{color: '#12161E'}]
          },
          {
            featureType: 'water',
            elementType: 'labels.text.fill',
            stylers: [{color: '#e0253f'}]
          },
          {
            featureType: 'water',
            elementType: 'labels.text.stroke',
            stylers: [{color: '#201720'}]
          }
        ],
        markers: [
          {
            position: {
              lat: 25.0699821, lng: 121.5210453
            },
            info: {
              content: '花博爭艷館'
            }
          }
        ]
      }
    }
  },
  computed: {
    ...mapGetters([
    ])
  },
  methods: {
  },
  mounted () {
    // Place images after loaded
    this.$Lazyload.$on('loaded', () => {
      console.log('Loaded')
    })
  },
  watch: {
  },
  beforeDestroy () {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="sass" scoped>
@import '~stylesheets/variables'
@import '~stylesheets/components'
@import '~stylesheets/mixin'
</style>



// WEBPACK FOOTER //
// activity.vue?13dc65e4